import { AUTH_SESSION_KEYS } from "../../constants/authFlowKeys";
import { LOCAL_AUTH_HOSTS } from "@utils/login/loginHelpers";
import { navigateToUrl } from "./authNavigationService";
import { getConfiguredAuthHosts, isAuthControlPath } from "./authRouteConfig";

const DESIRED_NAV_KEY = AUTH_SESSION_KEYS.DESIRED_NAV;

const parseDesiredNavUrl = (url) => {
  if (!url) {
    return null;
  }

  try {
    return new URL(url, globalThis.location.origin);
  } catch (error) {
    console.warn("Invalid desiredNav URL blocked.", error);
    return null;
  }
};

const isDisallowedDesiredNavPath = (pathname) => {
  return isAuthControlPath(pathname);
};

const canStoreDesiredNavUrl = (url) => {
  const parsedUrl = parseDesiredNavUrl(url);
  if (!parsedUrl) {
    return false;
  }

  if (isDisallowedDesiredNavPath(parsedUrl.pathname)) {
    console.warn("Blocked auth route desiredNav storage.", parsedUrl.pathname);
    return false;
  }

  return true;
};

export const getDesiredNav = () => {
  return sessionStorage.getItem(DESIRED_NAV_KEY);
};

export const setDesiredNav = (url) => {
  if (!canStoreDesiredNavUrl(url)) {
    return;
  }

  const parsedUrl = new URL(url, globalThis.location.origin);
  sessionStorage.setItem(DESIRED_NAV_KEY, parsedUrl.toString());
};

export const clearDesiredNav = () => {
  sessionStorage.removeItem(DESIRED_NAV_KEY);
};

export const rememberDesiredNav = (url = globalThis.location.href) => {
  if (getDesiredNav() !== url) {
    setDesiredNav(url);
  }
};

export const restoreDesiredNav = (url) => {
  setDesiredNav(url);
};

export const isAllowedDesiredNavUrl = (url, appSettings) => {
  const parsedUrl = parseDesiredNavUrl(url);
  if (!parsedUrl) {
    return false;
  }

  if (!/^https?:$/.test(parsedUrl.protocol)) {
    return false;
  }

  if (isDisallowedDesiredNavPath(parsedUrl.pathname)) {
    return false;
  }

  const allowedHosts = getConfiguredAuthHosts(appSettings);
  allowedHosts.add(globalThis.location.hostname);
  LOCAL_AUTH_HOSTS.forEach((host) => {
    allowedHosts.add(host);
  });

  return allowedHosts.has(parsedUrl.hostname);
};

export const consumeDesiredNavRedirect = (appSettings, navigate) => {
  const previousUrl = getDesiredNav();
  if (!previousUrl) {
    return false;
  }

  // Clear before navigating so a blocked or stale target cannot be replayed
  // again on the next auth/session transition.
  clearDesiredNav();

  const isAllowedRedirect = isAllowedDesiredNavUrl(previousUrl, appSettings);
  if (isAllowedRedirect) {
    return navigateToUrl({
      url: previousUrl,
      navigate,
      replace: true,
    });
  }

  console.warn("Blocked unsafe desiredNav redirect.", previousUrl);
  return false;
};
